import axios from 'axios';
const apiHost = process.env.VUE_APP_API_HOST;

export const redeemVoucher = async (voucher: string, msisdn: string) => {
  const form = new FormData();
  form.append('msisdn', msisdn);
  const response = await axios.post(`${apiHost}/ringcredible/v5/webshop/redeem_voucher`, {
    msisdn,
    voucher_code: voucher,
  });
  return response.data;
};
